import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { ErrorListDto } from '../../dto/error/ErrorLIstDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeleteError = async (dto: ErrorListDto) => {
  const params: IApiParams = {
    url: '/error/deleteInfo.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', dto);
};
